export function getDomain(): string {
  if (typeof window !== "undefined") {
    return window.location.host;
  } else {
    return '';
  }
}

export function getSubDomain(): string {
  if(process.env.NODE_ENV == 'production') {
  return getDomain().split('.')[1] + '.' + getDomain().split('.')[2];
  } else {
    return 'sydonelabs.com'
  }
}
